import { createFileRoute, Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import z from 'zod'
import SetPasswordForm from '@/components/forms/set-password-form/set-password-form'
import { AuthSplitLayout } from '@/components/layout/auth-split-layout'
import { Button } from '@/components/ui/button'

const searchSchema = z.object({
  oobCode: z.string().optional(),
  mode: z.string().optional(),
})

export const Route = createFileRoute('/activate-account')({
  validateSearch: searchSchema,
  component: SetPasswordPage,
})

function SetPasswordPage() {
  const { oobCode } = Route.useSearch()
  const { t } = useTranslation()

  return (
    <AuthSplitLayout>
      <div className="flex-1 flex flex-col justify-center w-full md:flex-none md:mb-6 md:space-y-6">
        <div className="flex flex-col gap-y-3">
          <h1 className="heading-1 text-center">{t('activateAccountPage.title')}</h1>
          <p className="body-1 text-text-secondary text-center">
            {t('activateAccountPage.description')}
          </p>
        </div>
      </div>

      <div className="w-full gap-6 flex flex-col">
        {oobCode ? (
          <SetPasswordForm oobCode={oobCode} />
        ) : (
          <div className="flex flex-col gap-4 items-center text-center">
            <p className="body-2 text-text-secondary">{t('activateAccountPage.invalidLink')}</p>
            <Link to="/login" className="w-full">
              <Button variant="background" className="w-full">
                {t('activateAccountPage.goToLoginButton')}
              </Button>
            </Link>
          </div>
        )}
      </div>
    </AuthSplitLayout>
  )
}
